
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      vxSubHeader: 'notification/getSubHeader',
      vxCustomer: 'customer/getCustomer',
      vxWording: 'navigation/getContent',
      vxLoyalty: 'loyalty/getProfile',
    }),
  },
  methods: {
    ...mapActions({
      vxOpenSwitchLocation: 'navigation/toggleSwitchLocation',
      vxCloseAll: 'navigation/closeAllDesktop',
    }),
    getCountry() {
      return this.$i18n.locale.includes('ca')
        ? 'CAN'
        : this.$i18n.locale.includes('eu')
        ? 'EUR'
        : 'USA'
    },
    getLang() {
      return this.$i18n.locale.includes('en') ? 'en' : 'fr'
    },
    getFirstName() {
      if (this.vxCustomer && this.vxCustomer.firstName) {
        const first_name = this.vxCustomer.firstName.toLowerCase()
        return `${first_name.charAt(0).toUpperCase()}${first_name.slice(1)}`
      }
    },
  },
}
